import { BASE_URL, REACT_APP_OLE_API_KEY } from "config";
import { ErrorResponse } from "./types";
import * as Sentry from '@sentry/react';

const getHashInfo = async (token: string, region: string): Promise<any> => {
    try {
        const response = await fetch(`${BASE_URL}/api-payments/v1/payments/pending/${token}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key': REACT_APP_OLE_API_KEY,
                'X-User': 'web',
            },
        });
        console.log("✅ [getHashInfo] Response received:", response);
        if (!response.ok) {
            Sentry.logger.error('linkService[getHashInfo] error', { session: token, status: response.status, message: await response.text() });
            return { status: response.status, message: await response.text(), error: true } as ErrorResponse;
        }
        const data = await response.json();
        Sentry.logger.info('linkService[getHashInfo]', { session: token, body: data });

        return data;
    } catch (error:any) {
        Sentry.logger.error('linkService[getHashInfo] exception', { session: token, error });
        if (error.status === 404) {
            throw new Error("La sesión no fue encontrada o expiró.");
          }
          if (error.status === 401) {
            throw new Error("No autorizado. Verifica tu API Key o token.");
          }
      
          throw new Error("Error inesperado al obtener la sesión de pago.");
    }
}

const isPaymentPending = async (idPayment: number | string): Promise<boolean> => {
    try {
        const response = await fetch(`${BASE_URL}/api-payments/v1/payments/is-pending/${idPayment}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key': REACT_APP_OLE_API_KEY,
                'X-User': 'web',
            },
        });
        if (!response.ok) {
            Sentry.logger.error('linkService[isPaymentPending] error', { idPayment, status: response.status, message: await response.text() });
            return true; // fail-open: un error de red no bloquea un pago legítimo
        }
        const data = await response.json();
        Sentry.logger.info('linkService[isPaymentPending]', { idPayment, body: data });
        return data?.is_pending === true;
    } catch (error) {
        Sentry.logger.error('linkService[isPaymentPending] exception', { idPayment, error });
        return true; // fail-open
    }
}

export { getHashInfo, isPaymentPending };